import esES from './es_ES';
import Calendar from '../calendar/locale/es_US';
import DatePicker from '../date-picker/locale/es_US';
const localeValues = {
    ...esES,
    locale: 'es-us',
    DatePicker,
    Calendar,
};
export default localeValues;
